import { createAsyncThunk } from '@reduxjs/toolkit'
import camelCaseKeys from 'camelcase-keys'
import ACTIONS from '../../constants'
import { reportAPI } from '../../../shared/api/ReportAPI'
import { AppState } from '../../store'
import { Report } from '../../../shared/model/models'

const { REPORT } = ACTIONS

export const setReports = createAsyncThunk<any, void, { state: AppState }>(
  REPORT.SET_REPORTS,
  async (_, { getState }) => {
    const {
      currentUser: { token },
    } = getState()
    if (token) {
      const values = await reportAPI.getReports()
      const reports = camelCaseKeys(values, { deep: true })
      return reports
    }
    return []
  },
)

export const setReport = createAsyncThunk<any, { reportId: number }, { state: AppState }>(
  REPORT.SET_REPORT,
  async ({ reportId }, { getState }) => {
    const {
      currentUser: { token },
    } = getState()
    if (token) {
      const values = await reportAPI.getReport(reportId)
      return camelCaseKeys(values, { deep: true })
    }
    return []
  },
)

export const updateReport = createAsyncThunk<any, { report: Report }, { state: AppState }>(
  REPORT.UPDATE_REPORT,
  async ({ report }, { getState }) => {
    const {
      currentUser: { token },
    } = getState()
    if (token) {
      await reportAPI.updateReport(report)
      return report
    }
    return null
  },
)

export const deleteReport = createAsyncThunk<any, { reportId: number }, { state: AppState }>(
  REPORT.DELETE_REPORT,
  async ({ reportId }, { getState }) => {
    const {
      currentUser: { token },
    } = getState()
    if (token) {
      await reportAPI.deleteReport(reportId)
      return reportId
    }
    return null
  },
)
